import script from "./vipCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./vipCard.vue?vue&type=script&setup=true&lang=ts"

import "./vipCard.vue?vue&type=style&index=0&id=068bcb1f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-068bcb1f"]])

export default __exports__